<template>
  <div v-show="showPray" class="zoom">
    <!-- titulo -->
    <v-row align="center">
      <v-col class="flex-grow-1 flex-shrink-0">
        <h4
          class="text-uppercase font-italic cyan--text"
          v-html="step.title"
        ></h4>
        <div class="caption grey--text">{{ step.subtitle }}</div>
      </v-col>
      <v-col class="flex-grow-0 flex-shrink-1" v-if="step.help">
        <v-btn icon class="ma-0" @click="showHelp = !showHelp">
          <v-icon color="primary lighten-1">help</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <!-- help -->
    <v-row class="ma-0" v-show="showHelp">
      <v-slide-y-transition>
        <v-col
          class="pa-4 mb-2 cyan lighten-4 grey--text text--darken-1"
          v-html="step.help"
        ></v-col>
      </v-slide-y-transition>
    </v-row>
    <!-- oraciones -->
    <v-row class="ma-0">
      <template v-for="pray in step.prays">
        <div :key="pray.id" class="my-2">
          <h4 class="cyan--text font-italic" v-html="pray.title"></h4>
          <div class="font-italic" v-html="pray.pray"></div>
          <div class="caption grey--text text-xs-right">{{ pray.credit }}</div>
        </div>
      </template>

      <slot></slot>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "mdd-paso-oracion",
  props: ["num", "control", "step"],
  data: () => {
    return {
      showHelp: false
    };
  },
  computed: {
    showPray() {
      return this.num === this.control || this.$route.params.filter === "noche";
    },
    t() {
      return this.$store.getters["app/trad/activa"];
    }
  }
};
</script>
